export default __webpack_public_path__ + "assets/ea691c7a6b58b04a8dd1634fe7c07e2b.woff2";